class ListCollection extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelectorAll(".list-collection-wrapper .button")
      this.button_active = this.querySelector(".list-collection-wrapper .button.is-active")
        
      this.collection_container = this.querySelector(".collection-wrapper.current-collection")
  
      this.attachEvent();

    }

    attachEvent() {
        this.list.forEach( button => button.addEventListener("click", this.swapCollection.bind(this)))
    }

    swapCollection(e) {
        if (e.target == this.button_active) return;
        this.button_active.classList.remove('button--primary', 'is-active')
        this.button_active.classList.add("button--link");
        this.collection_container.classList.add("hidden")
        this.button_active = e.target;

        // Swap primary
        this.collection_container = this.querySelector(`[data-target="${e.target.getAttribute('data-collection')}"]`)
        this.collection_container.classList.remove("hidden")
        this.button_active.classList.add('button--primary', 'is-active')
        this.button_active.classList.remove("button--link")
    }
  
}
  
customElements.define('list-collection', ListCollection);
  